import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { SubCategoryModel } from '@/model/subcategory';
import { CategoryModel } from '@/model/catlist';
import { SourceModel } from '@/model/source';
import { PriorityModel } from '@/model/priority';
import { TicketListModel } from '@/model/ticketList';
import { CategoryByIdModel } from '@/model/categoryById';
import { PlantListModel } from '@/model/plantList';
import { NocUserModel } from '@/model/nocUser';
import { UserProfile } from '../Interface/userProfile'
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    jwtTokan: string;
    private baseURL = environment.baseURL;

    // baseURL = 'https://api.zerocarbon.com.pk';
    // baseURL = 'https://staging.zerocarbon.com.pk';
    // ************************* Apart from ZC - Practice api **********************
    stripIntegration(id: number) {
        return this.http.get<any>(
            'http://localhost:8000/create-checkout-session/' + id + '/'
        )
    }
    //  *****************************************************************************

    // public user: any = null;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('tokan')
        })
    };
    // Live Base URL

    private profileImageSubject = new BehaviorSubject<string | null>(null);
    profileImage$ = this.profileImageSubject.asObservable();
    // Staging Base URL
    // baseURL = 'https://staging.zerocarbon.com.pk';

    getDecodedTokan: any;
    constructor(
        private router: Router,
        private http: HttpClient,
        private _serviceApi: ApiService
    ) { }

    updateUserProfilePic(imageSrcBase64: string) {
        this.profileImageSubject.next(imageSrcBase64);
    }

    loginUser(Username: string, Password: string): Observable<any> {
        return this.http
            .post<any>(
                this.baseURL + '/login',
                { username: Username, password: Password },
                this.httpOptions
            )
            .pipe(
                map((user) => {
                    this.jwtTokan = user.data.access_token;
                    localStorage.setItem('tokan', this.jwtTokan);
                    this.getDecodedTokan = this._serviceApi.decodeAuth();
                })
            );
    }

    setUserInfoApi(username, password) {
        return this.http.post<any>(
            this.baseURL + '/login',
            { username: username, password: password },
            this.httpOptions
        );
    }

    dashboard(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getDashboardDetails',
            this.httpOptions
        );
    }

    GetPlantStatus(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantsStatus',
            this.httpOptions
        );
    }

    GetPlantLocation(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getStationsLocation',
            this.httpOptions
        );
    }



    GetAlarmStatus(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAlarmsAndStatusCount',
            this.httpOptions
        );
    }

    // New dashboard APIs (2026 revamp)
    GetDashboardSummary(): Observable<any> {
        return this.http.get(
            this.baseURL + '/dashboard/summary/',
            this.httpOptions
        );
    }

    GetYieldStatistics(type: 'yearly' | 'lifetime', year?: number): Observable<any> {
        let url = this.baseURL + '/dashboard/yield-statistics/?type=' + type;
        if (type === 'yearly' && year) {
            url += '&year=' + year;
        }
        return this.http.get(url, this.httpOptions);
    }

    GetEnvironmentalBenefits(): Observable<any> {
        return this.http.get(
            this.baseURL + '/dashboard/environmental-benefits/',
            this.httpOptions
        );
    }

    GetDashboardWeather(): Observable<any> {
        return this.http.get(
            this.baseURL + '/dashboard/weather/',
            this.httpOptions
        );
    }

    GetTicketStats(): Observable<any> {
        return this.http.get(
            this.baseURL + '/dashboard/ticket-stats/',
            this.httpOptions
        );
    }

    GetFsrStats(): Observable<any> {
        return this.http.get(
            this.baseURL + '/dashboard/fsr-stats/',
            this.httpOptions
        );
    }

    GetPlantAlarmCountAPI(StationCode: any): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAlarmsCount?code=' + StationCode,
            this.httpOptions
        );
    }
    getMonthRoiGraph(StationCode: any): Observable<any> {
        return this.http.get(
            this.baseURL + '/getMonthlyRoiGraph?code=' + StationCode,
            this.httpOptions
        );
    }
    getYearlyRoiGraph(StationCode: any): Observable<any> {
        return this.http.get(
            this.baseURL + '/getYearlyRoiGraph?code=' + StationCode,
            // 'http://localhost:8000/getYearlyRoiGraph?code=' + StationCode,
            this.httpOptions
        );
    }


    PlantsdetailsAllApi(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAllPlants',
            this.httpOptions
        );
    }

    graphDetails(): Observable<any> {
        return this.http.get(this.baseURL + '/getPlantsCity', this.httpOptions);
    }
    Plantsdetails_old(): Observable<any> {
        return this.http.get(this.baseURL + '/getPlantsList', this.httpOptions);
    }
    Plantsdetails(): Observable<any> {
        return this.http.get(this.baseURL + '/plantListPortal', this.httpOptions);
    }
    // -------------- ADDED BY EMAN ---------------
    getAllPlantsdetails(search: string, page: number, size: number, sort: string, column: string, type: string, status: string, contractType: number, region: number, city: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};
        //   if (search!==null) {
        //     console.log('inside search',search)
        //     queryParams['search'] = search;
        //   }
        //   if (page !== 1) {
        //     queryParams['page'] = page;
        //   }
        //   if (size !== 10) {
        //     queryParams['size'] = size;
        //   }
        //   if (sort!==null && column!=null) {
        //     queryParams['sort'] = sort;
        //     queryParams['column'] = column;
        //   }
        //   if (type !== null) {
        //     queryParams['type'] = type;
        // }
        // if (status !== null) {
        //     queryParams['status'] = status;
        // }
        // Set name if provided
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                delete queryParams['page'];
                delete queryParams['size'];
                delete queryParams['type'];
                delete queryParams['status'];
                delete queryParams['contract_type_id'];
                delete queryParams['region_id'];
                delete queryParams['city_id'];
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            // Set department_id if provided
            if (type !== null) {
                queryParams['type'] = type;
            }

            // Set designation_id if provided
            if (status !== null) {
                queryParams['status'] = status;
            }
            // Set contract_type_id if provided
            if (contractType !== null) {
                queryParams['contract_type_id'] = contractType;
            }
            // Set region_id if provided
            if (region !== null) {
                queryParams['region_id'] = region;
            }
            // Set city_id if provided
            if (city !== null) {
                queryParams['city_id'] = city;
            }
        }
        return this.http
            .get(
                `${this.baseURL}/plantListPortal`, {
                headers,
                params: queryParams,
            }
            )
    }
    //  ---------------- End ------------------------
    FilteredPlantsdetails(filter: string): Observable<any> {
        return this.http.get(this.baseURL + '/plantListPortal?' + filter, this.httpOptions);
    }
    chanePasswordApi(changePass): Observable<any> {
        return this.http.post(this.baseURL + '/changePassword', changePass, this.httpOptions);
    }
    sendForgotApi(forgotPassword): Observable<any> {
        return this.http.post(this.baseURL + '/forgotPassword', forgotPassword, this.httpOptions);
    }
    saveUserApi(userList): Observable<any> {
        return this.http.post(this.baseURL + '/createAccount', userList, this.httpOptions);
    }
    updateUserApi(id: number, userList): Observable<any> {
        return this.http.patch(this.baseURL + `/edit-user/${id}/`, userList, this.httpOptions);
    }
    setChangePasswordApi(ChangePassword): Observable<any> {
        return this.http.post(this.baseURL + '/resetPassword', ChangePassword, this.httpOptions);
    }
    getNormalizePowerGraph(stationCode: any): Observable<any> {
        return this.http.post(this.baseURL + '/getNormalizePowerGraph', stationCode, this.httpOptions);
    }
    getAvailabilityGraph(stationCode: any): Observable<any> {
        return this.http.post(this.baseURL + '/getAvailabilityChart', stationCode, this.httpOptions);
    }
    plantStatus(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantsStatus',
            this.httpOptions
        );
    }
    setWeatherUpdatesApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL + '/getWeather?code=' + getStationCode,
            this.httpOptions
        );
    }
    getpowerFlowListApi(getStationCode): Observable<any> {
        return this.http.get(
            //this.baseURL + '/getPowerFlow?code=' + getStationCode, old API
            this.baseURL + '/newMobilePowerFlow?code=' + getStationCode,
            this.httpOptions
        );
    }

    getHeatMapListApi(getStationCode): Observable<any> {
        return this.http.get(
            //this.baseURL + '/getPowerFlow?code=' + getStationCode, old API
            this.baseURL + '/getInverterHeatmap?code=' + getStationCode,
            this.httpOptions
        );
    }

    pvgetDataApi_old(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getCurrentPVValuesByInverterId?code=' +
            getStationCode,
            this.httpOptions
        );
    }

    pvgetDataApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getCurrentPVValuesByInverterId?code=' +
            getStationCode,
            this.httpOptions
        );
    }

    setgetPlantDetailsApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantDetails?code=' + getStationCode,
            this.httpOptions
        );
    }
    countAlertlistApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAlarmsCount?code=' + getStationCode,
            this.httpOptions
        );
    }
    newPvGraphsListApi(devId, dt): Observable<any> {
        return this.http.get(
            this.baseURL + '/newPvGraphs?devId=' + devId + '&collectTime=' + dt,
            this.httpOptions
        );
    }


    receiveAlarmbyIDApi(getAlarm): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAlarmById?id=' + getAlarm,
            this.httpOptions
        );
    }
    getEnvBnifitsApi(getStationCode, dt, getDayRang): Observable<any> {
        return this.http.get(
            this.baseURL +
            //'/getEnvironmentalBenefit?code=' +
            '/newMobileGetEnvironmentalBenefit?code=' +
            getStationCode +
            '&time=' +
            dt +
            '&type=' +
            getDayRang,
            this.httpOptions
        );
    }
    getMonthChartApi_old(getStationCode, dt): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getMonthChart?code=' +
            getStationCode +
            '&time=' +
            dt,
            this.httpOptions
        );
    }
    getMonthChartApi(getStationCode, dt): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/newMobilePlantGraphMonthly?code=' +
            //'/getMonthChart?code=' +
            getStationCode +
            '&time=' +
            dt,
            this.httpOptions
        );
    }

    getYearChartApi(getStationCode, dt): Observable<any> {
        return this.http.get(
            this.baseURL +
            // '/getYearChart?code=' +
            '/newMobilePlantGraphYearly?code=' +
            getStationCode +
            '&time=' +
            dt,
            this.httpOptions
        );
    }
    // Added by Eman
    getLiftTimeChartApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/newMobilePlantGraphLifetime?code=' +
            getStationCode,
            this.httpOptions
        );
    }
    // ----------------------------- end ------------------
    logout() {
        localStorage.removeItem('tokan');
        localStorage.removeItem('gatekeeper_token');
        this.loginUser = null;
        this.router.navigate(['/login']);
    }

    setfiveMinDataApi_old(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL + '/fiveMinData?code=' + getStationCode,
            this.httpOptions
        );
    }

    setfiveMinDataApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantGenerationAndConsumptionDaily?code=' + getStationCode,
            this.httpOptions
        );
    }
    setfiveMinDataApiWithDate_old(getStationCode, dtEnv): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/fiveMinData?code=' +
            getStationCode +
            '&time=' +
            dtEnv,
            this.httpOptions
        );
    }

    setfiveMinDataApiWithDate(getStationCode, dtEnv): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getPlantGenerationAndConsumptionDaily?code=' +
            getStationCode +
            '&time=' +
            dtEnv,
            this.httpOptions
        );
    }

    setEmiGraphApiWithDate(getStationCode, dtEnv): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getEmiGraph?code=' +
            getStationCode +
            '&time=' +
            dtEnv,
            this.httpOptions
        );
    }
    inverterPrimeDataApi_old(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/getInvertersStats?code=' +
            getStationCode,
            this.httpOptions
        );
    }

    inverterPrimeDataApi(getStationCode): Observable<any> {
        return this.http.get(
            this.baseURL +
            '/newMobileInvertersList?code=' +
            getStationCode,
            this.httpOptions
        );
    }

    sendSubCatApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getSubCategoryList', this.httpOptions)
            .pipe(
                map((res) => {
                    const subcats = res && res['data'];
                    return subcats.map((e) => new SubCategoryModel(e));
                })
            );
    }

    receiveCategoryApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getCategoryList', this.httpOptions)
            .pipe(
                map((res) => {
                    const category = res && res['data'];
                    return category.map((e) => new CategoryModel(e));
                })
            );
    }

    receiveSourceApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getAllSource', this.httpOptions)
            .pipe(
                map((res) => {
                    const source = res && res['data'];
                    return source.map((e) => new SourceModel(e));
                })
            );
    }

    receivePreorityApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getPriorityList', this.httpOptions)
            .pipe(
                map((res) => {
                    const priortyVar = res && res['data'];
                    return priortyVar.map((e) => new PriorityModel(e));
                })
            );
    }


    // receiveTicketListApi(): Observable<any> {

    //     //return this.http.get(this.baseURL + '/getAllComplaints', this.httpOptions);

    //     return this.http
    //         .get(this.baseURL + '/getAllComplaints', this.httpOptions)
    //         .pipe(
    //             map((res) => {
    //                 const tLVar = res && res['data'];
    //                 const ticketList = tLVar.map((e) => new TicketListModel(e));
    //                 // Return the modified response
    //                 return {
    //                     ...res,
    //                     data: ticketList, 
    //                 };
    //              })
    //         );
    // }
    receiveTicketListApi(search: string): Observable<any> {

        //return this.http.get(this.baseURL + '/getAllComplaints', this.httpOptions);

        return this.http
            .get(this.baseURL + '/getAllComplaints?search=' + search, this.httpOptions)
            .pipe(
                map((res) => {
                    const tLVar = res && res['data'];
                    const ticketList = tLVar.map((e) => new TicketListModel(e));
                    // Return the modified response
                    return {
                        ...res,
                        data: ticketList,
                    };
                })
            );
    }
    // ----------------- Added by Eman --------------------------
    receiveAllTicketListApi(search: string, page: number, size: number, sort: string, column: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};

        // if (search && search.trim() !== '') {
        //     queryParams['search'] = search;
        //     if (search !== '') {
        //       delete queryParams['page'];
        //       delete queryParams['size'];
        //     }
        //   } else {
        //     // Set page if greater than 1 or if size is provided
        //     if (page > 1) {
        //       queryParams['page'] = page;
        //     }

        //     // Set size if greater than 10
        //     if (size && size > 10) {
        //       queryParams['size'] = size;
        //     }
        //     if (sort!==null && column!=null) {
        //             queryParams['sort'] = sort;
        //             queryParams['column'] = column;
        //     }
        //   }
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (size > 10) {
                        queryParams['size'] = size
                    }
                    else {
                        delete queryParams['size'];
                    }
                }
                else {
                    if (size) {
                        queryParams['size'] = size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http
            .get(
                `${this.baseURL}/getAllComplaints`, {
                headers,
                params: queryParams,
            }
            )
    }
    //  -------------------- Added By Eman -------------------
    FilterRecvieTicketListApi(filter: string): Observable<any> {
        return this.http
            .get(this.baseURL + '/getAllComplaints?' + filter, this.httpOptions)
            .pipe(
                map((res) => {
                    const tLVar = res && res['data'];
                    const ticketList = tLVar.map((e) => new TicketListModel(e));
                    // Return the modified response
                    return {
                        ...res,
                        data: ticketList,
                    };
                })
            );
    }


    recvieTicketListApi(ticektId): Observable<any> {
        return this.http
            .get(this.baseURL + '/getComplaintByTicketId?ticket_id=' + ticektId, this.httpOptions)
            .pipe(
                map((res) => {
                    const tLVar = res && res['data'];
                    return tLVar.map((e) => new TicketListModel(e));
                })
            );
    }
    receiveUserApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getAllUsers', this.httpOptions)
            .pipe(
            // map((res) => {
            //     const userVar = res && res['data'];
            //     return userVar.map((e) => new UserModel(e));
            // })
        );
    }
    receiveAllUsers(search: string, page: number, size: number, sort: string | null, column: string | null, user_type: number, role: number | null, status: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};

        // Always include sort & column if they exist
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (size > 10) {
                        queryParams['size'] = size
                    }
                    else {
                        delete queryParams['size'];
                    }
                }
                else {
                    if (size) {
                        queryParams['size'] = size
                    }
                    if (user_type != null) {
                        queryParams['user_type'] = user_type;
                    } else {
                        delete queryParams['user_type'];
                    }
                    if (role != null) {
                        queryParams['role'] = role;
                    } else {
                        delete queryParams['role'];
                    }
                    if (status != null) {
                        queryParams['status'] = status;
                    } else {
                        delete queryParams['status'];
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            // Set department_id if provided
            if (user_type !== null) {
                queryParams['user_type'] = user_type;
            }
            if (role !== null) {
                queryParams['role'] = role;
            }
            if (status !== null) {
                queryParams['is_active'] = status;
            }
        }
        return this.http.get(`${this.baseURL}/getAllUsers`, {
            headers,
            params: queryParams,
        });
    }
    receiveInactiveUsers(search: string, page: number, size: number, sort: string | null, column: string | null, user_type: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};

        // Always include sort & column if they exist
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (size > 10) {
                        queryParams['size'] = size
                    }
                    else {
                        delete queryParams['size'];
                    }
                }
                else {
                    if (size) {
                        queryParams['size'] = size
                    }
                    if (user_type != null) {
                        queryParams['user_type'] = user_type;
                    } else {
                        delete queryParams['user_type'];
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            // Set department_id if provided
            if (user_type !== null) {
                queryParams['user_type'] = user_type;
            }
        }
        return this.http.get(`${this.baseURL}/getInactiveUsers`, {
            headers,
            params: queryParams,
        });
    }


    receiveAllTraiffTypes(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/getAllTariffTypes`, {
            headers,
            params: queryParams,
        });
    }
    receivedropdownTraiffTypes(): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.get(`${this.baseURL}/getAllTariffTypesForDropDown`, { headers });
    }

    addTariffTypes(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffType`, body, this.httpOptions)
    }
    editTariffTypes(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffType`, body, this.httpOptions)
    }
    deleteTariffTypes(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/deleteTariffType`, body, this.httpOptions)
    }
    receiveAllTraiffCompanies(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/getAllTariffCompanies`, {
            headers,
            params: queryParams,
        });
    }
    receivedropdownCompanyTariff(): Observable<any> {
        return this.http.get(
            this.baseURL + '/getAllTariffCompaniesForDropDown',
            this.httpOptions
        );
    }

    addTariffCompany(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffCompany`, body, this.httpOptions)
    }
    editTariffCompany(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffCompany`, body, this.httpOptions)
    }
    deleteTariffCompany(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/deleteTariffCompany`, body, this.httpOptions)
    }
    receiveAllPlantTariffs(search: string, page: number, page_size: number,
        sort: string | null, column: string | null,
        tariff_company: number | null,
        tariff_type: number | null,
        plant_id: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['size'] = page_size
                    }
                    else {
                        delete queryParams['size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['size'] = page_size
                    }
                    if (tariff_company != null) {
                        queryParams['tariff_company'] = tariff_company;
                    } else {
                        delete queryParams['tariff_company'];
                    }
                    if (tariff_type != null) {
                        queryParams['tariff_type'] = tariff_type;
                    } else {
                        delete queryParams['tariff_type'];
                    }
                    if (plant_id != null) {
                        queryParams['plant_id'] = plant_id;
                    } else {
                        delete queryParams['plant_id'];
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
            if (tariff_company !== null) {
                queryParams['tariff_company'] = tariff_company;
            }
            if (tariff_type !== null) {
                queryParams['tariff_type'] = tariff_type;
            }
            if (plant_id !== null) {
                queryParams['plant_id'] = plant_id;
            }
        }
        return this.http.get(`${this.baseURL}/getPlantTariff`, {
            headers,
            params: queryParams,
        });
    }

    addPlantTariff(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/linkPlantTariff`, body, this.httpOptions)
    }
    editPlantTariff(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/editPlantTariff`, body, this.httpOptions)
    }
    deletePlantTariff(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/deleteTariffCompany`, body, this.httpOptions)
    }

    receiveAllTariffRates(search: string, page: number, page_size: number,
        sort: string | null, column: string | null,
        tariff_company: number | null,
        tariff_type: number | null,
        year: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page_size'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    if (tariff_company != null) {
                        queryParams['tariff_company'] = tariff_company;
                    } else {
                        delete queryParams['tariff_company'];
                    }
                    if (tariff_type != null) {
                        queryParams['tariff_type'] = tariff_type;
                    } else {
                        delete queryParams['tariff_type'];
                    }
                    if (year != null) {
                        queryParams['year'] = year;
                    } else {
                        delete queryParams['year'];
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
            if (tariff_company !== null) {
                queryParams['tariff_company'] = tariff_company;
            }
            if (tariff_type !== null) {
                queryParams['tariff_type'] = tariff_type;
            }
            if (year !== null) {
                queryParams['year'] = year;
            }
        }
        return this.http.get(`${this.baseURL}/getTariffRates`, {
            headers,
            params: queryParams,
        });
    }

    addTariffRates(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffRate`, body, this.httpOptions)
    }
    editTariffRates(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/addEditTariffRate`, body, this.httpOptions)
    }
    deleteTariffRates(id: any): Observable<any> {
        return this.http.delete<any>(`${this.baseURL}/deleteTariffRate/${id}/`, this.httpOptions)
    }

    FilterreceiveUserApi(filter: string): Observable<any> {
        return this.http
            .get(this.baseURL + '/getAllUsers?' + filter, this.httpOptions)
            .pipe(
            // map((res) => {
            //     const userVar = res && res['data'];
            //     return userVar.map((e) => new UserModel(e));
            // })
        );
    }
    receiveNocUserApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getNocUsers', this.httpOptions)
            .pipe(
                map((res) => {
                    const userVar = res && res['data'];
                    return userVar.map((e) => new NocUserModel(e));
                })
            );
    }

    selectCategoryRowApi(sendIdCat): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getCategoryById?id=' + sendIdCat,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const catRow = res && res['data'];
                    return catRow.map((e) => new CategoryByIdModel(e));
                })
            );
    }
    categoryEditApi(categoryEdit): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditCategory',
            categoryEdit,
            this.httpOptions
        );
    }
    addSubCatApi(getSubcatadd): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditSubCategory',
            getSubcatadd,
            this.httpOptions
        );
    }
    showLinkPlantApi(userInlist): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantOwners?userid=' +
            userInlist,
            this.httpOptions
        );
    }

    showLinkUserApi(userInlist): Observable<any> {
        return this.http.get(
            this.baseURL + '/getPlantOwners?userid=' +
            userInlist,
            this.httpOptions
        );
    }


    deleteCategoryApi(id): Observable<any> {
        return this.http.post(
            this.baseURL + '/deleteCategory?id=' + id,
            this.httpOptions
        );
    }
    deletePriortyListApi(deletePri): Observable<any> {
        return this.http.post(
            this.baseURL + '/deletePriority?id=' + deletePri,
            this.httpOptions
        );
    }
    deleteSubCategoryApi(deleteSubCat): Observable<any> {
        return this.http.post(
            this.baseURL + '/deleteSubCategory?id=' + deleteSubCat,
            this.httpOptions
        );
    }
    deleteSourceListApi(deleteSource): Observable<any> {
        return this.http.post(
            this.baseURL + '/deleteSource?id=' + deleteSource,
            this.httpOptions
        );
    }
    receiveSubCatDateaPI(catid): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getSubCategoryById?id=' + catid,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const subCatUpdate = res && res['data'];
                    return subCatUpdate.map((e) => new SubCategoryModel(e));
                })
            );
    }

    getPriorityUpdateApi(getPriorityId): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getPriorityById?id=' + getPriorityId,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const getprioryVar = res && res['data'];
                    return getprioryVar.map((e) => new PriorityModel(e));
                })
            );
    }
    getSourceByidApi(getUpdateId): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getSourceById?id=' + getUpdateId,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const getprioryVar = res && res['data'];
                    return getprioryVar.map((e) => new PriorityModel(e));
                })
            );
    }
    addPriorityApi(priAdd): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditPriority',
            priAdd,
            this.httpOptions
        );
    }
    linkUserPlantsApi(LinkPlantU): Observable<any> {
        return this.http.post(
            this.baseURL + '/linkPlantOwners',
            LinkPlantU,
            this.httpOptions
        );
    }
    updatePriorityListApi(priUpdateModel): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditPriority',
            priUpdateModel,
            this.httpOptions
        );
    }
    updateSourceListApi(updateSourceModel): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditSource',
            updateSourceModel,
            this.httpOptions
        );
    }
    addSourceListApi(addSourceModel): Observable<any> {
        return this.http.post(
            this.baseURL + '/addEditSource',
            addSourceModel,
            this.httpOptions
        );
    }
    addComplainListApi(addComplan): Observable<any> {
        return this.http.post(
            this.baseURL + '/addTicketWeb',
            addComplan,
            this.httpOptions
        );
    }
    getPlantsListApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/getAllPlants', this.httpOptions)
            .pipe(
                map((res) => {
                    const getPlantList = res && res['data'];
                    return getPlantList.map((e) => new PlantListModel(e));
                })
            );
    }

    getCategoryBySourceIdApi(sourceId): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getCategoryBySource?source=' + sourceId,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const getCBSi = res && res['data'];
                    return getCBSi.map((e) => new CategoryModel(e));
                })
            );
    }
    getSubCategoryByCatIdApi(catId): Observable<any> {
        return this.http
            .get(
                this.baseURL + '/getSubCategoryByCategory?category=' + catId,
                this.httpOptions
            )
            .pipe(
                map((res) => {
                    const getCBSi = res && res['data'];
                    return getCBSi.map((e) => new SubCategoryModel(e));
                })
            );
    }
    // receiveAlarmApi(): Observable<any> {
    //     return this.http
    //         .get(
    //             this.baseURL + '/getAlarmsList' ,
    //             this.httpOptions
    //         )
    // }
    clearAlarms(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/clearAlarms`, body, this.httpOptions)
    }
    unClearAlarms(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/unclearAlarms`, body, this.httpOptions)
    }
    receiveAlarmApi(): Observable<any> {
        return this.http
            .get(
                this.baseURL + `/getAlarmsList`, this.httpOptions
            )
    }
    // Added By Eman
    receiveAllAlarmApi(search: string, page: number, size: number, sort: string | null, column: string | null,
        stationCode: number | null, region: number | null, lev: number | null
    ): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};
        if (search !== null) {
            console.log('inside search', search)
            queryParams['search'] = search;
        }
        if (page !== 1) {
            queryParams['page'] = page;
        }
        if (size !== 10) {
            queryParams['size'] = size;
        }
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        if (stationCode !== null) {
            queryParams['station_code'] = stationCode;
        }
        if (region !== null) {
            queryParams['region'] = region;
        }
        if (lev !== null) {
            queryParams['lev'] = lev;
        }
        // if (search && search.trim() !== '') {
        //     queryParams['search'] = search;
        //     if (search !== '') {
        //     delete queryParams['page'];
        //     delete queryParams['size'];
        //     }
        // } else {
        //     // Set page if greater than 1 or if size is provided
        //     if (page > 1) {
        //     queryParams['page'] = page;
        //     }

        //     // Set size if greater than 10
        //     if (size && size > 10) {
        //     queryParams['size'] = size;
        //     }
        //     if (sort!==null && column!=null) {
        //             queryParams['sort'] = sort;
        //             queryParams['column'] = column;
        //     }
        // }
        return this.http
            .get(
                `${this.baseURL}/getAlarmsList`, {
                headers,
                params: queryParams,
            }
            )
    }
    receiveAlarmByStation(search: string, page: number, size: number, sort: string | null, column: string | null, stationCode?: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};
        if (search !== null && search.trim() !== '') {
            console.log('inside search', search);
            queryParams['search'] = search;
        }
        if (page !== 1) {
            queryParams['page'] = page;
        }
        if (size !== 10) {
            queryParams['size'] = size;
        }
        if (stationCode !== null) {
            queryParams['station_code'] = stationCode;
        }
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        // if (search && search.trim() !== '') {
        //     queryParams['search'] = search;
        //     if (search !== '') {
        //     delete queryParams['page'];
        //     delete queryParams['size'];
        //     }
        // } else {
        //     // Set page if greater than 1 or if size is provided
        //     if (page > 1) {
        //     queryParams['page'] = page;
        //     }

        //     // Set size if greater than 10
        //     if (size && size > 10) {
        //     queryParams['size'] = size;
        //     }
        //     if (sort!==null && column!=null) {
        //             queryParams['sort'] = sort;
        //             queryParams['column'] = column;
        //     }
        // }
        return this.http
            .get(
                `${this.baseURL}/getAlarmsList`, {
                headers,
                params: queryParams,
            }
            )
    }
    receiveHistoricalAlarm(search: string, page: number, size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};
        if (search !== null) {
            queryParams['search'] = search;
        }
        if (page !== 1) {
            queryParams['page'] = page;
        }
        if (size !== 10) {
            queryParams['size'] = size;
        }
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        return this.http
            .get(
                `${this.baseURL}/getHistoricalAlarms`, {
                headers,
                params: queryParams,
            }
            )
    }

    receiveAlarmApiFilter(filter: string): Observable<any> {
        console.log('search', filter)
        return this.http
            .get(
                this.baseURL + '/getAlarmsList?search=' + filter,
                this.httpOptions
            )
    }
    changeStatusApi(priortylist): Observable<any> {
        return this.http.post(
            this.baseURL + '/changeTicketStatus',
            priortylist,
            this.httpOptions
        );
    }
    changePrioritySelectApi(changePrioritySelect): Observable<any> {
        return this.http.post(
            this.baseURL + '/changeTicketPriority',
            changePrioritySelect,
            this.httpOptions
        );
    }
    changeAssignToSendApi(selectUser): Observable<any> {
        return this.http.post(
            this.baseURL + '/changeTicketAssignee',
            selectUser,
            this.httpOptions
        );
    };

    removeUserPlantApi(removeLinkPlantList): Observable<any> {

        return this.http.post(
            this.baseURL + '/unlinkPlantOwners',
            removeLinkPlantList,
            this.httpOptions
        );
    }
    setInverterDcGrApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getInverterInputDCGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    setNormalizdGraphApi(receivestationResult, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPlantNormalizePowerGraph?code=' +
            receivestationResult + '&time=' + setDate,
            this.httpOptions
        );
    }
    setInverterOPGrApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getInverterOutputGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    setInverterNOmalPGraPI(stData): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPlantNormalizePowerGraph?code=NE=' +
            stData,
            this.httpOptions
        );
    }




    getPvVoltageGraphApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvVoltageGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    getPVcurrentValuesApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvCurrentGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    getPVPowerValuesApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvPowerGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    getBothVoltageCurrentsendApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvVoltageCurrentGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    getBothVoltagePowersendApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvVoltagePowerGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    getBothCurrentPowersendApi(stData, setDate): Observable<any> {

        return this.http.get(
            this.baseURL + '/getPvCurrentPowerGraph?devId=' +
            stData + '&time=' + setDate,
            this.httpOptions
        );
    }
    selectUserTypeAPI(): Observable<any> {

        return this.http.get(this.baseURL + '/getUserTypes', this.httpOptions);
    }


    updateInstallationCostApi(stationCode, installationCost): Observable<any> {
        const formData = new FormData();
        formData.append('code', stationCode);
        formData.append('cost', installationCost.toString());
        return this.http.post(
            this.baseURL + '/updateStation',
            { code: stationCode, cost: parseFloat(installationCost) },
            this.httpOptions
        );
    }
    reCalculateRoiApi(stationCode): Observable<any> {
        return this.http.post(
            this.baseURL + '/reCalculateGraph',
            { code: stationCode },
            this.httpOptions
        );
    }

    predictedRoiApi(requestbody): Observable<any> {
        return this.http.post(
            this.baseURL + '/predictedRoi',
            requestbody,
            this.httpOptions
        );
    }



    getCommentsApi(ticketId): Observable<any> {

        return this.http.get(
            this.baseURL + '/getComments?ticket_id=' +
            ticketId,
            this.httpOptions
        );
    }

    addCommentsApi(ticketId, comment, files, type): Observable<any> {


        var httpOptions2 = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem('tokan')
            })
        };

        const formData = new FormData();
        formData.append('ticket_id', ticketId);
        // formData.append('ticket_id', ticketId); // Replace with your form data
        if (type == 1) {
            formData.append('comment', comment);
        }
        else {

            for (let i = 0; i < files.length; i++) {
                formData.append('media', files[i]);
            }
            // formData.append('media', files);
        }


        return this.http.post(
            this.baseURL + '/addComment',
            formData,
            httpOptions2
        );
    }


    disableUserApi(userId): Observable<any> {
        return this.http.post(
            this.baseURL + '/disableUser',
            { user_id: userId },
            this.httpOptions
        );
    }
    enableUserApi(userId): Observable<any> {
        return this.http.post(
            this.baseURL + '/enableUser',
            { user_id: userId },
            this.httpOptions
        );
    }

    getUserProfile(userId: string): Observable<any> {
        return this.http.get(
            this.baseURL + '/getProfile?user_id=' + userId, this.httpOptions);
    }

    updateUserProfile(userId: string, userProfile: UserProfile): Observable<any> {
        return this.http.post(
            this.baseURL + '/updateProfile',
            { user_id: userId, full_name: userProfile.name, contact: userProfile.contact, email: userProfile.email, address: userProfile.address, profile_picture: userProfile.profile_picture },
            this.httpOptions
        );
    }
    receiveCitites(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/cities/`, {
            headers,
            params: queryParams,
        });
    }
    addRegionAndCity(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/cities/create/`, body, this.httpOptions)
    }
    editRegionAndCity(body: any): Observable<any> {
        const id = body.id;
        delete body.id;
        return this.http.patch<any>(`${this.baseURL}/cities/${id}/update/`, body, this.httpOptions)
    }
    deleteRegionAndCity(id: number): Observable<any> {
        return this.http.delete<any>(`${this.baseURL}/cities/${id}/delete/`, this.httpOptions)
    }
    // Dropdowns
    getContractTypeDropDownApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/contract-types/', this.httpOptions)
            .pipe(
                map((res) => {
                    return res && res['data']['response'];
                })
            );
    }
    getRegionDropDownApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/regions/', this.httpOptions)
            .pipe(
                map((res) => {
                    return res && res['data']['response'];
                })
            );
    }
    getCititesDropDownApi(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/cities/', this.httpOptions)
            .pipe(
                map((res) => {
                    return res && res['data']['response'];
                })
            );
    }
    getCititesByRegionDropDownApi(id: number): Observable<any> {
        return this.http
            .get(this.baseURL + `/dropdown/region-city/?region_id=${id}`, this.httpOptions)
            .pipe(
                map((res) => {
                    return res && res['data']['response'];
                })
            );
    }
    updateRegionCityPlant(body: any): Observable<any> {
        return this.http.patch<any>(`${this.baseURL}/plantListPortal/association/`, body, this.httpOptions)
    }
    getNearbyPlants(search: string, page: number, size: number, sort: string | null, column: string | null, lat: number, lng: number, radius: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search)
        const queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
        }
        if (page !== 1) {
            queryParams['page'] = page;
        }
        if (size !== 10) {
            queryParams['size'] = size;
        }
        if (lat !== null) {
            queryParams['lat'] = lat;
        }
        if (lng !== null) {
            queryParams['lng'] = lng;
        }

        if (radius !== null) {
            queryParams['radius'] = radius;
        }
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        return this.http
            .get(
                `${this.baseURL}/plantListPortal/get-nearby-stations/`, {
                headers,
                params: queryParams,
            }
            )
    }
    getNearbyEmiStations(lat: number, lng: number, radius: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (lat !== null) {
            queryParams['lat'] = lat;
        }
        if (lng !== null) {
            queryParams['lng'] = lng;
        }
        if (radius !== null) {
            queryParams['radius'] = radius;
        }
        return this.http
            .get(
                `${this.baseURL}/plantListPortal/get-nearby-weather-stations/`, {
                headers,
                params: queryParams,
            }
            )
    }
    // analysis heat map 
    getEMIHeatMap(search: string, page: number, size: number, sort: string, column: string, type: string, status: string, contractType: number, region: number, city: number,
        stationCodes: number[] | null, fromDate?: string | null, toDate?: string | null
    ): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                delete queryParams['page'];
                delete queryParams['size'];
                delete queryParams['type'];
                delete queryParams['status'];
                delete queryParams['contract_type_id'];
                delete queryParams['region_id'];
                delete queryParams['city_id'];
                delete queryParams['station_codes'];
                delete queryParams['start_date_date'];
                delete queryParams['end_date_date'];
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            // Set department_id if provided
            if (type !== null) {
                queryParams['type'] = type;
            }

            // Set designation_id if provided
            if (status !== null) {
                queryParams['status'] = status;
            }
            // Set contract_type_id if provided
            if (contractType !== null) {
                queryParams['contract_type_id'] = contractType;
            }
            // Set region_id if provided
            if (region !== null) {
                queryParams['region_id'] = region;
            }
            // Set city_id if provided
            if (city !== null) {
                queryParams['city_id'] = city;
            }
            // Set Station codes if provided
            if (stationCodes && stationCodes.length > 0) {
                queryParams['station_codes'] = stationCodes;
            }
            if (fromDate !== null && fromDate !== undefined) {
                queryParams['start_date'] = fromDate
            }
            if (toDate !== null && toDate !== undefined) {
                queryParams['end_date'] = toDate
            }
        }
        return this.http
            .get(
                `${this.baseURL}/plantListPortal/yield-heat-map/`, {
                headers,
                params: queryParams,
            }
            )
    }
    getStationsDropDown(): Observable<any> {
        return this.http.get(
            this.baseURL + '/stations/dropdown/',
            this.httpOptions
        );
    }
    getWapdaData(station_code: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (station_code !== null) {
            queryParams['station_code'] = station_code;
        }
        return this.http
            .get(
                `${this.baseURL}/wapda-generated-Tab/`, {
                headers,
                params: queryParams,
            }
            )
    }
    getDevicesData(station_code: string, search?: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (station_code !== null) {
            queryParams['station_code'] = station_code;
        }
        if (search) {
            queryParams['search'] = search;
        }
        return this.http
            .get(
                `${this.baseURL}/deviceList-generated-Tab/`, {
                headers,
                params: queryParams,
            })
    }
    getPlantsTree(user_id: any): Observable<any> {
        return this.http.get(this.baseURL + `/get-station-owner/?user_id=${user_id}`, this.httpOptions);
    }
    updateUserPlant(body: any): Observable<any> {
        return this.http.patch<any>(`${this.baseURL}/associate-station-owner/`, body, this.httpOptions)
    }
    receivePlantAlarmApi(search: string, page: number, size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (search !== null) {
            console.log('inside search', search)
            queryParams['search'] = search;
        }
        if (page !== 1) {
            queryParams['page'] = page;
        }
        if (size !== 10) {
            queryParams['size'] = size;
        }
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }

        return this.http
            .get(
                `${this.baseURL}/getAlarmById`, {
                headers,
                params: queryParams,
            }
            )
    }
    // daily report
    fetchDailyReport(stationCode: string | null, date: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // let queryParams: any = {};
        // if (stationCode !== null) {
        //     queryParams['station_code'] = stationCode;
        // }
        // if (date !== null) {
        //     queryParams['date'] = date;
        // }
        const body = {
            station_code: stationCode,
            date: date
        };
        return this.http.post(`${this.baseURL}/plant-daily-report/`, body, { headers });
    }
    downloadDailyReport(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post(`${this.baseURL}/plant-daily-report-download/`, body, { headers, responseType: 'blob' });
    }
    // monthly report
    fetchMonthlyReport(payload: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post(`${this.baseURL}/plant-monthly-report/`, payload, { headers });
    }
    downloadMonthlyReport(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post(`${this.baseURL}/plant-monthly-report-download/`, body, { headers, responseType: 'blob' });
    }
    resetUserPassworod(payload: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/set-default-password`, payload, this.httpOptions)
    }
    downloadDevicesReport(stationCode: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.get(`${this.baseURL}/deviceListReport?code=${stationCode}`, { headers, responseType: 'blob' as 'json' });
    }
    downloadActiveAlarmReport(queryParams: any): Observable<Blob> {
        let params = new HttpParams();

        // Convert body to query parameters
        Object.entries(queryParams).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                params = params.append(key, value.toString());
            }
        });

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.get(`${this.baseURL}/getAlarmsListReport`, {
            headers,
            params,
            responseType: 'blob'
        });
    }
    downloadPlantReport(queryParams: any): Observable<Blob> {
        let params = new HttpParams();
        // Convert body to query parameters
        Object.entries(queryParams).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                params = params.append(key, value.toString());
            }
        });

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.get(`${this.baseURL}/plantListPortalReport`, {
            headers,
            params,
            responseType: 'blob'
        });
    }
    getStationInverterData(station_code: string, type?: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (station_code !== null) {
            queryParams['code'] = station_code;
        }
        if (type !== null) {
            queryParams['devType'] = type;
        }
        return this.http
            .get(
                `${this.baseURL}/station-inverters-dropdown/`, {
                headers,
                params: queryParams,
            })
    }
    getWapdaGraphicalView(devId, powerDevId, dt): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (devId !== null) {
            queryParams['gridDevId'] = devId;
        }
        if (powerDevId !== null) {
            queryParams['powerDevId'] = powerDevId;
        }
        if (dt !== null) {
            queryParams['dt'] = dt;
        }
        return this.http.get(
            `${this.baseURL}/wapda-devices-graphical-view/`, {
            headers,
            params: queryParams,
        })
    }
    downloadWapdaReport(stationCode: string, date: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const payload = {
            station_code: stationCode,
            date: date
        }
        return this.http.post(`${this.baseURL}/wapda-generator-report/`, payload, { headers, responseType: 'blob' as 'json' });
    }
    getPlantComparisonReport(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post(`${this.baseURL}/plant-comparison-excel/`, body, { headers, responseType: 'json' });
    }
    downloadPlantComparisonReport(body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post(`${this.baseURL}/plant-comparison-excel/`, body, { headers, responseType: 'blob' });
    }
    // user types
    userTypesList(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/user-type/`, {
            headers,
            params: queryParams,
        });
    }
    addUserType(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/user-type/`, body, this.httpOptions)
    }
    editUserType(body: any): Observable<any> {
        const id = body.id;
        const updatedBody = { ...body };
        delete updatedBody.id;   // remove id from body
        return this.http.patch<any>(`${this.baseURL}/user-type/${id}/`, updatedBody, this.httpOptions);
    }
    getUserTypesDropdown(): Observable<any> {
        return this.http
            .get(this.baseURL + '/user-type/dropdown/', this.httpOptions)
            .pipe(
                map((res) => {
                    // && res['data']['response']
                    return res;
                })
            );
    }
    getUserTypesHierarchyDropdown(): Observable<any> {
        return this.http
            .get(this.baseURL + '/user-type/hierarchy-dropdown/', this.httpOptions)
            .pipe(
                map((res) => {
                    // && res['data']['response']
                    return res;
                })
            );
    }
    // users role
    getUserRole(): Observable<any> {
        return this.http.get<any>(`${this.baseURL}/role/`, this.httpOptions);
    }
    createUserRole(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/role/`, body, this.httpOptions)
    }
    getRolePermissions(role_id: number): Observable<any> {
        const params = new HttpParams().set('role', role_id.toString());
        return this.http.get<any>(`${this.baseURL}/role-menu/get_role_menus/`, { ...this.httpOptions, params })
    }
    updateRolePermissions(permissions: any) {
        return this.http.patch<any>(`${this.baseURL}/role-menu/update_role_menus/`, permissions, this.httpOptions)
    }
    updateUserRole(id: number, payload: any) {
        return this.http.patch<any>(`${this.baseURL}/role/${id}/`, payload, this.httpOptions)
    }
    deleteUserRole(id: number) {
        return this.http.delete<any>(`${this.baseURL}/role/${id}/`, this.httpOptions)
    }
    getUserCreationHierarchyRules(): Observable<any> {
        return this.http
            .get(this.baseURL + '/user-creation-hierarchy/', this.httpOptions)
            .pipe(
                map((res) => {
                    // && res['data']['response']
                    return res;
                })
            );
    }
    createHierarchyRules(payload: any) {
        return this.http.post<any>(`${this.baseURL}/user-creation-hierarchy/`, payload, this.httpOptions)
    }
    deleteHierarchyRule(id: number) {
        return this.http.delete<any>(`${this.baseURL}/user-creation-hierarchy/${id}/`, this.httpOptions)
    }
    // user management update
    getUserRoleByType(id?: number): Observable<any> {
        const params = new HttpParams().set('user_type', id.toString());
        return this.http.get<any>(`${this.baseURL}/user-type/roles-dropdown/`, { ...this.httpOptions, params })
    }
    // audit trail user
    getAuditTrail(
        search: string,
        page: number,
        size: number,
        sort: string | null,
        column: string | null,
        changed_by: string | null,
        event_type: string | null,
        action_type: number | null,
        fromDate?: string | null,
        toDate?: string | null
    ): Observable<any> {

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        const queryParams: any = {};

        /* ---------------- SEARCH ---------------- */
        if (search && search.trim() !== '') {
            queryParams['search'] = search;

            // Reset pagination & filters on new search
            delete queryParams['page'];
            delete queryParams['size'];
            delete queryParams['sort'];
            delete queryParams['column'];
            delete queryParams['changed_by'];
            delete queryParams['event_type'];
            delete queryParams['action_type'];
            delete queryParams['start_date'];
            delete queryParams['end_date'];

        } else {

            /* ---------------- PAGINATION ---------------- */
            if (page > 1) {
                queryParams['page'] = page;
            }

            if (size && size > 10) {
                queryParams['size'] = size;
            }

            /* ---------------- SORTING ---------------- */
            if (sort && column) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            /* ---------------- FILTERS ---------------- */
            if (changed_by) {
                queryParams['changed_by'] = changed_by;
            }

            if (event_type) {
                queryParams['event_type'] = event_type;
            }

            if (action_type !== null) {
                queryParams['action_type'] = action_type;
            }

            /* ---------------- DATE RANGE ---------------- */
            if (fromDate) {
                queryParams['start_date'] = fromDate;
            }

            if (toDate) {
                queryParams['end_date'] = toDate;
            }
        }

        return this.http.get(
            `${this.baseURL}/system-activities/`,
            {
                headers,
                params: queryParams,
            }
        );
    }
    getAllUsersDropdown(): Observable<any> {
        return this.http.get(this.baseURL + '/users-dropdown/', this.httpOptions)
    }
    // roles list Paginated
    rolesListPaginated(search: string, page: number, page_size: number, sort: string | null, column: string | null, user_type: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
            if (user_type !== null) {
                queryParams['user_type'] = user_type;
            }
        }
        return this.http.get(`${this.baseURL}/role/paginated/`, {
            headers,
            params: queryParams,
        });
    }
    downloadUsersReport(filters: any): Observable<Blob> {
        let params = new HttpParams();

        Object.keys(filters || {}).forEach(key => {
            const value = filters[key];
            if (value !== null && value !== undefined && value !== '') {
                params = params.append(key, value);
            }
        });

        const headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.get(`${this.baseURL}/users/export/`, {
            headers,
            params,
            responseType: 'blob'
        });
    }
    // ticket management
    getTicketPriority(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/priority/`, {
            headers,
            params: queryParams,
        });
    }
    addTicketPriority(body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/priority/`, body, this.httpOptions)
    }
    editTicketPriority(body: any): Observable<any> {
        const id = body.id;
        const updatedBody = { ...body };
        delete updatedBody.id;   // remove id from body
        return this.http.patch<any>(`${this.baseURL}/priority/${id}/`, updatedBody, this.httpOptions);
    }
    deletePriority(id: number): Observable<any> {
        return this.http.delete<any>(`${this.baseURL}/priority/${id}/`, this.httpOptions)
    }
    // ticket configuration
    getCongfigurationList(search: string, page: number, page_size: number, sort: string | null, column: string | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        // console.log('search', search);
        let queryParams: any = {};
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (page_size > 10) {
                        queryParams['page_size'] = page_size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (page_size) {
                        queryParams['page_size'] = page_size
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (page_size && page_size > 10) {
                queryParams['page_size'] = page_size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }
        }
        return this.http.get(`${this.baseURL}/ticket-configurations/`, {
            headers,
            params: queryParams,
        });
    }
    updateCongfiguration(body: any): Observable<any> {
        const id = body.id;
        const updatedBody = { ...body };
        delete updatedBody.id;   // remove id from body
        return this.http.patch<any>(`${this.baseURL}/ticket-configurations/${id}/`, updatedBody, this.httpOptions);
    }
    // ticket list
    getTicketList(search: string, page: number, size: number, sort: string | null, column: string | null, assignee: number | null, priority: number | null, status: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        console.log('search', search);
        let queryParams: any = {};

        // Always include sort & column if they exist
        if (sort !== null && column != null) {
            queryParams['sort'] = sort;
            queryParams['column'] = column;
        }
        if (search && search.trim() !== '') {
            queryParams['search'] = search;
            if (search !== '') {
                if (page > 1) {
                    queryParams['page'] = page;
                    if (size > 10) {
                        queryParams['page_size'] = size
                    }
                    else {
                        delete queryParams['page_size'];
                    }
                }
                else {
                    if (size) {
                        queryParams['page_size'] = size
                    }
                    if (assignee != null) {
                        queryParams['assignee'] = assignee;
                    } else {
                        delete queryParams['assignee'];
                    }
                    if (priority != null) {
                        queryParams['priority'] = priority;
                    } else {
                        delete queryParams['priority'];
                    }
                    if (status != null) {
                        queryParams['status'] = status;
                    } else {
                        delete queryParams['status'];
                    }
                    delete queryParams['page'];
                }
            }
        } else {
            // Set page if greater than 1 or if size is provided
            if (page > 1) {
                queryParams['page'] = page;
            }

            // Set size if greater than 10
            if (size && size > 10) {
                queryParams['page_size'] = size;
            }
            if (sort !== null && column != null) {
                queryParams['sort'] = sort;
                queryParams['column'] = column;
            }

            // Set department_id if provided
            if (assignee !== null) {
                queryParams['assignee'] = assignee;
            }
            if (priority !== null) {
                queryParams['priority'] = priority;
            }
            if (status !== null) {
                queryParams['is_active'] = status;
            }
            if (status != null) {
                queryParams['status'] = status;
            } else {
                delete queryParams['status'];
            }
        }
        return this.http.get(`${this.baseURL}/tickets/`, {
            headers,
            params: queryParams,
        });
    }
    assignedTicketUsers(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/assigned-users/', this.httpOptions)
    }
    assignedTicketUsersFsr(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/assigned-users-fsr/', this.httpOptions)
    }
    getTicketStatusList(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/ticket-status/', this.httpOptions)
    }
    getFsrStatusList(): Observable<any> {
        return this.http
            .get(this.baseURL + '/dropdown/fsr-status/', this.httpOptions)
    }
    fetchSeverity(): Observable<any> {
        return this.http.get(this.baseURL + '/getSeverityList', this.httpOptions)
    }
    fetchStationInfo(stationId?: number | null, electrician?: number | null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        const queryParams: any = {};
        if (stationId !== null) {
            queryParams['stationId'] = stationId;
        }
        if (electrician !== null) {
            queryParams['electrician'] = electrician;
        }
        return this.http
            .get(
                `${this.baseURL}/stations/owner-dropdown/`, {
                headers,
                params: queryParams,
            }
            )
    }
    createTicket(body: any): Observable<any> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/`, body, { headers })
    }
    updateTicket(id: number, payload: any): Observable<any> {   // remove id from payload
        const headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.patch<any>(`${this.baseURL}/tickets/${id}/`, payload, { headers });
    }
    assignTicket(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/assign/`, body, { headers })
    }
    startTicket(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/start/`, null, { headers })
    }
    holdTicket(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/on_hold/`, body, { headers })
    }
    pendingTicket(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/pending_material/`, body, { headers })
    }
    resolveTicket(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/resolve/`, null, { headers })
    }
    closeTicketApi(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/close/`, body, { headers })
    }
    reopenTicket(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/reopen/`, body, { headers })
    }
    cancelTicket(id: number, body: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/cancel/`, body, { headers })
    }
    getTicketDetail(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.get(`${this.baseURL}/tickets/${id}/`, { headers });
    }
    getTicketCommunication(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.get(`${this.baseURL}/tickets/${id}/communications/`, { headers });
    }
    sendMessage(id: number, body: FormData): Observable<any> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.post<any>(`${this.baseURL}/tickets/${id}/communications/`, body, { headers })
    }
    getNotifications(type: 'details' | 'communication', page: number = 1): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });
        return this.http.get<any>(
            `${this.baseURL}/notifications/?type=${type}&page=${page}&page_size=15`,
            { headers }
        );
    }
    postNotifications(body: { type: 'details' | 'communication' }): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post<any>(
            `${this.baseURL}/notifications/`,
            body,
            { headers }
        );
    }
    markNotificationRead(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post<any>(
            `${this.baseURL}/notifications/${id}/mark_read/`,
            {},
            { headers }
        );
    }
    markAllNotificationsRead(body: { type: 'details' | 'communication' }): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post<any>(
            `${this.baseURL}/notifications/mark_all_read/`,
            body,
            { headers }
        );
    }
    clearNotification(id: number): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post<any>(
            `${this.baseURL}/notifications/${id}/clear/`,
            {},
            { headers }
        );
    }
    clearAllNotifications(body: { type: 'details' | 'communication' }): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        });

        return this.http.post<any>(
            `${this.baseURL}/notifications/clear_all/`,
            body,
            { headers }
        );
    }
    // ---------------------------------------------------------------------
    // FSR (Field Service Report)
    //
    // No explicit Authorization header: TokanInterceptor rewrites it on every
    // outgoing request. Content-Type is omitted on the multipart calls so the
    // browser can set its own boundary.
    // ---------------------------------------------------------------------

    getFsrList(filters: {
        search?: string;
        page?: number;
        size?: number;
        sort?: string | null;
        column?: string | null;
        assignee?: number | null;
        status?: number | null;
        origin?: string | null;
        job_visit_type?: string | null;
        city?: number | null;
    } = {}): Observable<any> {
        const { search, page, size, sort, column } = filters;
        let params = new HttpParams();

        if (search && search.trim() !== '') {
            params = params.set('search', search.trim());
        }
        if (page && page > 1) {
            params = params.set('page', page);
        }
        if (size && size !== 10) {
            params = params.set('page_size', size);
        }
        if (sort != null && column != null) {
            params = params.set('sort', sort).set('column', column);
        }
        // The rest are plain pass-through filters, so set whichever are present.
        (['assignee', 'status', 'origin', 'job_visit_type', 'city'] as const).forEach((key) => {
            const value = filters[key];
            if (value !== null && value !== undefined && value !== '') {
                params = params.set(key, value as any);
            }
        });

        return this.http.get(`${this.baseURL}/fsr/`, { params });
    }

    getFsrDetail(id: number): Observable<any> {
        return this.http.get(`${this.baseURL}/fsr/${id}/`);
    }

    createFsr(body: FormData): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/`, body);
    }

    updateFsr(id: number, body: FormData): Observable<any> {
        return this.http.patch<any>(`${this.baseURL}/fsr/${id}/`, body);
    }

    assignFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/assign/`, body);
    }

    startFsr(id: number): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/start/`, {});
    }

    holdFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/on_hold/`, body);
    }

    pendingFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/pending_material/`, body);
    }

    resolveFsr(id: number): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/resolve/`, {});
    }

    closeFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/close/`, body);
    }

    reopenFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/reopen/`, body);
    }

    cancelFsr(id: number, body: any): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/cancel/`, body);
    }

    approveFsr(id: number): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/fsr/${id}/approve/`, {});
    }

    getFsrConfigurationList(search: string): Observable<any> {
        let params = new HttpParams();
        if (search && search.trim() !== '') {
            params = params.set('search', search.trim());
        }
        return this.http.get(`${this.baseURL}/fsr-configurations/`, { params });
    }

    updateFsrConfiguration(body: any): Observable<any> {
        const id = body.id;
        const payload = { ...body };
        delete payload.id;
        return this.http.patch<any>(`${this.baseURL}/fsr-configurations/${id}/`, payload);
    }

    getFsrJobVisitTypes(): Observable<any> {
        return this.http.get(`${this.baseURL}/dropdown/fsr-job-visit-type/`);
    }

    getFsrComplaintTypes(): Observable<any> {
        return this.http.get(`${this.baseURL}/dropdown/fsr-complaint-type/`);
    }

    /** The Corrective FSR filed against a ticket (404 when none exists yet). */
    getTicketFsr(ticketId: number): Observable<any> {
        return this.http.get(`${this.baseURL}/tickets/${ticketId}/fsr/`);
    }

    /** Creates the Corrective FSR on first call, updates it thereafter. */
    saveTicketFsr(ticketId: number, body: FormData): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/tickets/${ticketId}/fsr/`, body);
    }

    // ---------------------------------------------------------------------
    // Panel inventory (string configuration, panels, approval workflow)
    //
    // Same conventions as the FSR block above: no explicit Authorization
    // header (TokanInterceptor), JSON body for every action/list endpoint.
    // ---------------------------------------------------------------------

    getBrandsDropdown(): Observable<any> {
        return this.http.get(`${this.baseURL}/brands/dropdown/`)
            .pipe(map((res: any) => res && res['data']['response']));
    }

    getPanelStatusesDropdown(): Observable<any> {
        return this.http.get(`${this.baseURL}/panel-statuses/dropdown/`)
            .pipe(map((res: any) => res && res['data']['response']));
    }

    getInverterModelsDropdown(): Observable<any> {
        return this.http.get(`${this.baseURL}/inverter-models/dropdown/`)
            .pipe(map((res: any) => res && res['data']['response']));
    }

    getStringConfigurations(filters: { search?: string; page?: number; page_size?: number } = {}): Observable<any> {
        let params = new HttpParams();
        if (filters.search && filters.search.trim() !== '') {
            params = params.set('search', filters.search.trim());
        }
        if (filters.page && filters.page > 1) {
            params = params.set('page', filters.page);
        }
        if (filters.page_size && filters.page_size !== 10) {
            params = params.set('page_size', filters.page_size);
        }
        return this.http.get(`${this.baseURL}/string-configurations/`, { params });
    }

    setStringConfiguration(body: { invType: string; no_of_strings: number }): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/string-configurations/`, body);
    }

    getPlantInverters(stationCode: string): Observable<any> {
        return this.http.get(`${this.baseURL}/plant-inverters/dropdown/`, { params: new HttpParams().set('stationCode', stationCode) })
            .pipe(map((res: any) => res && res['data']['response']));
    }

    getPvStringsDropdown(inverterDevId: number): Observable<any> {
        return this.http.get(`${this.baseURL}/pv-strings/dropdown/`, { params: new HttpParams().set('inverter', inverterDevId) })
            .pipe(map((res: any) => res && res['data']['response']));
    }

    getPanelsList(filters: {
        plant?: number | string | null;
        inverter?: number | null;
        string?: number | null;
        brand?: number | null;
        status?: string | null;
        search?: string;
        page?: number;
        size?: number;
    } = {}): Observable<any> {
        const { search, page, size } = filters;
        let params = new HttpParams();
        if (search && search.trim() !== '') {
            params = params.set('search', search.trim());
        }
        if (page && page > 1) {
            params = params.set('page', page);
        }
        if (size && size !== 10) {
            params = params.set('page_size', size);
        }
        (['plant', 'inverter', 'string', 'brand', 'status'] as const).forEach((key) => {
            const value = filters[key];
            if (value !== null && value !== undefined && value !== '') {
                params = params.set(key, value as any);
            }
        });
        return this.http.get(`${this.baseURL}/panels/`, { params });
    }

    bulkCreatePanels(body: { pv: number; panels: Array<{ sr_no: string; brand: number; series_name: string; capacity_kw: number | string }> }): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panels/bulk-create/`, body);
    }

    bulkTransferPanels(body: { panel_ids: number[]; destination_pv: number; reason?: string }): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panels/bulk-transfer/`, body);
    }

    bulkDisposePanels(body: { panel_ids: number[]; reason?: string }): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panels/bulk-dispose/`, body);
    }

    bulkSellPanels(body: { panel_ids: number[]; reason?: string }): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panels/bulk-sell/`, body);
    }

    approvePanelRequest(id: number): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panel-requests/${id}/approve/`, {});
    }

    rejectPanelRequest(id: number): Observable<any> {
        return this.http.post<any>(`${this.baseURL}/panel-requests/${id}/reject/`, {});
    }

    getPanelConfigurationList(search: string): Observable<any> {
        let params = new HttpParams();
        if (search && search.trim() !== '') {
            params = params.set('search', search.trim());
        }
        return this.http.get(`${this.baseURL}/panel-configurations/`, { params });
    }

    updatePanelConfiguration(body: any): Observable<any> {
        const id = body.id;
        const payload = { ...body };
        delete payload.id;
        return this.http.patch<any>(`${this.baseURL}/panel-configurations/${id}/`, payload);
    }

    getSubscription(userId: number, reportType: 'DAILY' | 'MONTHLY') {
        const params = new HttpParams()
            .set('user', userId)
            .set('report_type', reportType);

        return this.http.get(`${this.baseURL}/subscription/`, { params });
    }
    createSubscription(payload): Observable<any> {
        return this.http.post(this.baseURL + '/subscription/', payload, this.httpOptions);
    }
    updateSubscription(payload: any): Observable<any> {
        return this.http.put(this.baseURL + `/subscription/`, payload, this.httpOptions);
    }
    deleteSubscription(payload): Observable<any> {
        return this.http.delete<any>(`${this.baseURL}/subscription/`, {
            ...this.httpOptions,
            body: payload
        });
    }

    // ==================== Structural Field Details ====================

    getStructureTypesDropdown(): Observable<any> {
        return this.http
            .get(this.baseURL + '/structure-types/dropdown/', this.httpOptions)
            .pipe(map((res) => res && res['data']['response']));
    }
    getStructureSubTypesDropdown(structureTypeId: number): Observable<any> {
        return this.http
            .get(this.baseURL + `/structure-sub-types/dropdown/?structure_type=${structureTypeId}`, this.httpOptions)
            .pipe(map((res) => res && res['data']['response']));
    }
    getMaterialCompositionsDropdown(): Observable<any> {
        return this.http
            .get(this.baseURL + '/material-compositions/dropdown/', this.httpOptions)
            .pipe(map((res) => res && res['data']['response']));
    }
    getStructuralFieldDetails(stationCode: string): Observable<any> {
        // Station codes contain '=' (e.g. NE=51465290), so encode them.
        return this.http.get(this.baseURL + `/structural-field-details/?stationCode=${encodeURIComponent(stationCode)}`, this.httpOptions);
    }
    saveStructuralFieldDetails(body: any): Observable<any> {
        return this.http.post<any>(this.baseURL + '/structural-field-details/', body, this.httpOptions);
    }
}
